const playerCountElements = document.querySelectorAll(
  '.wp-block-plarium-content-cta__content__player-number',
);

/**
 * Player Counter
 *
 * This function animates a number from a start to an end value
 *
 * @param {HTMLElement} element - The element to update.
 * @param {number} start - The start number.
 * @param {number} end - The end number.
 * @param {number} duration - The duration of the animation.
 *
 */
function playerCounter(element, start, end, duration) {
  if (start === end) {
    return;
  }

  let current = start;
  const range = end - start;
  const increment = end > start ? 1 : -1;
  const step = Math.abs(Math.floor(duration / range));
  const timer = setInterval(() => {
    current += increment;
    // eslint-disable-next-line no-param-reassign -- Changes the number in the element
    element.textContent = current.toLocaleString();
    if (current === end) {
      clearInterval(timer);
    }
  }, step);
}

document.addEventListener('DOMContentLoaded', () => {
  if (!playerCountElements) {
    return;
  }

  playerCountElements.forEach((playerCountElement) => {
    const playerCountStart = playerCountElement
      ? parseInt(playerCountElement.textContent.replace(/,/g, ''), 10)
      : 0;

    // Get the player count ID from the element.
    // This is the offset * 2 to obsure it from the markup.
    // We use this ID to calculate the end number.
    const playerCountId = playerCountElement.getAttribute('data-pc-id');
    const playerCountEnd = playerCountId / 2 + playerCountStart;

    // Calculate the duration of the animation to keep consistency.
    const playerCountDuration = (playerCountEnd - playerCountStart) * 60;
    playerCounter(playerCountElement, playerCountStart, playerCountEnd, playerCountDuration);
  });
});
